import { createRoot } from "react-dom/client";
import App from "./App";
import data from "./contracts/clients/marriel/business.json";
import type { BusinessContract } from "./contracts/types";
import "./index.css";
import { applySeoFromBusiness } from "./seo/applySeoFromBusiness";

try {
  applySeoFromBusiness(data as BusinessContract);
} catch (e) {
  console.error("[seo] applySeoFromBusiness failed", e);
}

createRoot(document.getElementById("root")!).render(<App />);
